import { colors } from '../../foundation';

type Props = {
  color?: typeof colors.state.success | (typeof colors.white)[100];
  size?: number;
};

const Success = ({ color = colors.state.success, size }: Props) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="StateIcon/Notification Tick">
        <path
          id="Vector"
          d="M7.97917 1.35425C6.66063 1.35425 5.3717 1.74524 4.27537 2.47778C3.17904 3.21033 2.32456 4.25152 1.81997 5.46969C1.31539 6.68787 1.18337 8.02831 1.4406 9.32152C1.69784 10.6147 2.33277 11.8026 3.26512 12.735C4.19747 13.6673 5.38536 14.3022 6.67857 14.5595C7.97177 14.8167 9.31222 14.6847 10.5304 14.1801C11.7486 13.6755 12.7898 12.821 13.5223 11.7247C14.2548 10.6284 14.6458 9.33946 14.6458 8.02091C14.6439 6.25341 13.9408 4.55887 12.691 3.30906C11.4412 2.05925 9.74667 1.35623 7.97917 1.35425ZM12.4167 5.28008L6.36417 11.3334L3.54417 8.51091C3.48424 8.44795 3.45128 8.36406 3.45231 8.27714C3.45335 8.19021 3.4883 8.10713 3.54971 8.04561C3.61113 7.98409 3.69414 7.94899 3.78106 7.9478C3.86798 7.94662 3.95193 7.97943 4.015 8.03925L6.36417 10.3876L11.9433 4.80841C11.9743 4.77734 12.0111 4.75266 12.0516 4.7358C12.0921 4.71894 12.1355 4.71022 12.1794 4.71014C12.2233 4.71006 12.2668 4.71863 12.3073 4.73535C12.3479 4.75207 12.3848 4.77661 12.4158 4.80758C12.4469 4.83855 12.4716 4.87534 12.4885 4.91585C12.5053 4.95635 12.514 4.99978 12.5141 5.04366C12.5142 5.08753 12.5056 5.131 12.4889 5.17156C12.4722 5.21213 12.4476 5.249 12.4167 5.28008Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default Success;
